import React from "react";
import { Box, Button, Typography } from "@material-ui/core";
import { useHistory } from "react-router-dom";

const Fallback = ({ _error, _resetErrorBoundary }) => {
  const history = useHistory();
  return (
    <Box
      height="100vh"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
      <Typography variant="h1">Oops!</Typography>
      <Typography variant="body1">
        Something went wrong, and we're not sure what. Contact{" "}
        <a href="mailto:support@biblioboard.com">support@biblioboard.com</a> for
        help.
      </Typography>
      <Button onClick={() => history.push("/")}>Go home</Button>
    </Box>
  );
};

export default Fallback;
